import { useIntl } from 'react-intl';

import { getDeviceImage } from 'utils/Devices';

interface AccessoryCardProps {
  option: IDeviceOrderingOption;
}

export const AccessoryCard = ({ option }: AccessoryCardProps) => {
  const intl = useIntl();

  return (
    <div
      className="d-flex align-items-center gap-3 rounded-3 p-3 accessory-card"
      data-test={`accessory-card-${option.sku}`}
    >
      <div className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-3 bg-light accessory-card-image">
        <img
          src={getDeviceImage(option.displayName)}
          alt={intl.formatMessage({ id: option.displayName })}
          className="object-fit-contain"
        />
      </div>
      <div>
        <div className="d-flex align-items-center gap-2">
          <span className="fw-semibold">{intl.formatMessage({ id: option.displayName })}</span>
          {option.isDefaultAccessory && (
            <span className="badge bg-success-subtle text-success">
              {intl.formatMessage({ id: 'includedKey' })}
            </span>
          )}
        </div>
        <div className="text-secondary small">{option.sku}</div>
        {option.details && (
          <div className="small">
            <span className="text-dark">
              {option.details.in.min}&quot; – {option.details.in.max}&quot;
            </span>{' '}
            <span className="text-secondary">
              ({option.details.cm.min} – {option.details.cm.max} cm)
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
